import { render, staticRenderFns } from "./AmnioticAttachments.vue?vue&type=template&id=10a0c968&scoped=true&"
import script from "./AmnioticAttachments.vue?vue&type=script&lang=js&"
export * from "./AmnioticAttachments.vue?vue&type=script&lang=js&"
import style0 from "./AmnioticAttachments.vue?vue&type=style&index=0&id=10a0c968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a0c968",
  null
  
)

export default component.exports